import "./style.sass";
import { ProfileHeader } from "./profileHeader";
import { Preferences } from "./preferences";
import { Security } from "./security";
import { Footer } from "./footer";
import { AppSettings } from "./appSettings";
import useHandler from "./handler";

export const Profile = () => {
  const {
    preferences,
    accessData,
    showPopup,
    selectedPreference,
    getMediums,
    setShowPopup,
    setSelectedPreference,
    setPreferences,
    setAccessData,
    userProfileUpdate,
    getMediumOfInstructionsInProfile,
  } = useHandler();
  return (
    <>
      <section className="profile-page">
        <ProfileHeader />
        <Preferences
          preferences={preferences}
          setPreferences={setPreferences}
          onUpdate={userProfileUpdate}
          accessData={accessData}
          setAccessData={setAccessData}
          showPopup={showPopup}
          selectedPreference={selectedPreference}
          setShowPopup={setShowPopup}
          setSelectedPreference={setSelectedPreference}
          getMediumProfile={getMediumOfInstructionsInProfile}
          getMediums={getMediums}
        />
        {/* <AppSettings /> */}
        <Security />
      </section>
      <Footer preferences={preferences} setPreferences={setPreferences} />
    </>
  );
};
